import React, { createContext, useContext } from 'react';
import { useSocket } from '../../hooks/useSocket/useSocket';

interface SocketContextType {
  socket: any; // You might want to replace `any` with a more specific type if possible.
  online: boolean;
}

export const SocketContext = createContext<SocketContextType | undefined>(undefined);

export const SocketProvider = ({ children }) => {
  const { socket, online } = useSocket();

  return <SocketContext.Provider value={{ socket, online }}>{children}</SocketContext.Provider>;
};

// Custom hook for using the socket context
export const useSocketContext = () => {
  const context = useContext(SocketContext);
  if (!context) {
    throw new Error('lol ERROR: useSocketContext must be used within a SocketProvider');
  }
  return context;
};
